<template>
  <div class="space-y-4">
    <p class="text-sm text-gray-600">
      <i18n-t keypath="ticketPurchase.payment.reviewOrder" tag="span">
        <template #seller
          ><span class="font-semibold text-[#2e234b]">{{
            sellerName
          }}</span></template
        >
      </i18n-t>
    </p>
    <div class="space-y-3 rounded-xl border bg-gray-50 p-4">
      <div class="flex justify-between text-sm text-gray-700">
        <span>{{ $t("ticketPurchase.payment.contact") }}</span>
        <span>{{
          guestEmail || $t("ticketPurchase.payment.willUseAccountEmail")
        }}</span>
      </div>
    </div>
    <div
      class="flex items-center justify-between rounded-xl bg-[#2e234b] p-4 text-white"
    >
      <div>
        <div class="text-sm uppercase tracking-wide">
          {{ $t("ticketPurchase.payment.total") }}
        </div>
        <div class="text-2xl font-bold">
          {{ formatPrice(totalPrice, currency) }}
        </div>
      </div>
      <!-- <GradientButton :text="checkoutStatus ? 'PAYMENT SENT' : 'PAY NOW'" @click="$emit('payNow')" /> -->
    </div>
    <p
      v-if="checkoutStatus"
      class="rounded-lg border border-green-100 bg-green-50 p-3 text-sm text-green-700"
    >
      {{ checkoutStatus }}
    </p>
  </div>
</template>

<script setup lang="ts">
import { formatPrice } from "~~/shared/utils/formatPrice";
import { computed } from "vue";
import type { SelectedLineItem, TicketEntry } from "./types";

type ServiceOptionLike = {
  id?: string | number;
  name?: string;
  price?: number;
  currency?: string;
};

const props = defineProps<{
  ticketEntries: TicketEntry[];
  selectedTicketsList: SelectedLineItem[];
  serviceOptions: ServiceOptionLike[];
  guestEmail: string;
  totalPrice: number;
  currency: string;
  checkoutStatus: string | null;
  sellerName: string;
}>();

const guestEmail = computed(() => props.guestEmail);
const totalPrice = computed(() => props.totalPrice);
const currency = computed(() => props.currency);
const checkoutStatus = computed(() => props.checkoutStatus);
const sellerName = computed(() => props.sellerName);

defineEmits<{
  (e: "payNow"): void;
}>();
</script>
